﻿export class CloneRequested {
    static eventName() { return 'CloneRequested'; }

    eventName = CloneRequested.eventName;
}